import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const PopOutIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "PopOut",
    children: /*#__PURE__*/_jsx("path", {
      d: "M24.46 2h-9.73c-2.09 0-3.79 1.7-3.79 3.79v4.89a1.05 1.05 0 1 0 2.1 0V5.79c0-.94.76-1.7 1.7-1.7h9.73c.94 0 1.7.76 1.7 1.7v20.42c0 .94-.76 1.7-1.7 1.7h-9.73c-.94 0-1.7-.76-1.7-1.7v-4.9a1.05 1.05 0 1 0-2.1 0v4.9c0 2.09 1.7 3.79 3.79 3.79h9.73c2.09 0 3.79-1.7 3.79-3.79V5.79c0-2.09-1.7-3.79-3.79-3.79m-4.87 15.05a1.05 1.05 0 1 0 0-2.1H9.06V12.5c0-.38-.31-.69-.69-.69-.18 0-.34.07-.46.18s-3.93 3.48-3.93 3.48c-.15.13-.24.32-.24.52s.09.4.24.52S7.88 20 7.88 20c.12.11.28.18.46.18.38 0 .69-.31.69-.69v-2.45h10.55Z"
    })
  }));
};